import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface InfoFullIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const InfoFullIcon: React.FC<InfoFullIconProps> = ({
  width = 17,
  height = 16,
  color = '#58B929',
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 17 16" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1663 8.00065C15.1663 11.6825 12.1816 14.6673 8.49967 14.6673C4.81778 14.6673 1.83301 11.6825 1.83301 8.00065C1.83301 4.31875 4.81778 1.33398 8.49967 1.33398C12.1816 1.33398 15.1663 4.31875 15.1663 8.00065ZM8.49967 11.834C8.77582 11.834 8.99967 11.6101 8.99967 11.334V7.33398C8.99967 7.05784 8.77582 6.83398 8.49967 6.83398C8.22353 6.83398 7.99967 7.05784 7.99967 7.33398V11.334C7.99967 11.6101 8.22353 11.834 8.49967 11.834ZM8.49967 4.66732C8.86786 4.66732 9.16634 4.96579 9.16634 5.33398C9.16634 5.70217 8.86786 6.00065 8.49967 6.00065C8.13148 6.00065 7.83301 5.70217 7.83301 5.33398C7.83301 4.96579 8.13148 4.66732 8.49967 4.66732Z"
        fill={color}
      />
    </Svg>
  );
};

export default InfoFullIcon;
